
let language = {
    FILE_LIBRARY_UPLOAD_RESULT_UPLOAD_FILE_TITLE: "Upload Files",
    FILE_LIBRARY_UPLOAD_RESULT_HEADER_IMAGE_NAME: "image",
    FILE_LIBRARY_UPLOAD_RESULT_HEADER_IMAGE_INFO: "info",
    FILE_LIBRARY_UPLOAD_RESULT_HEADER_FILE_STATUS: "status",

    FILE_LIBRARY_UPLOAD_RESULT_FILE_NAME: "Name:",
    FILE_LIBRARY_UPLOAD_RESULT_FILE_TYPE: "Type:",
    FILE_LIBRARY_UPLOAD_RESULT_FILE_SIZE: "Size:",
    FILE_LIBRARY_UPLOAD_RESULT_UPLOAD_ERR_MSG: "Message:",

    FILE_LIBRARY_UPLOAD_RESULT_CLOSE_UPLOADING_MODAL_TIP: "Uploading file, after closing upload file will be lost! Are you sure to close upload modal?",

    // 
    FILE_LIBRARY_UPLOAD_RESULT_CONFIRM_BTN: "confirm",
    FILE_LIBRARY_UPLOAD_RESULT_CANCEL_BTN: "cancel",
    FILE_LIBRARY_UPLOAD_RESULT_UPLOAD_BTN: "upload",
    FILE_LIBRARY_UPLOAD_RESULT_OK_BTN: "ok",
    
    FILE_LIBRARY_UPLOAD_RESULT_STATUS_TYPE_SUCCESS: "Success",
    FILE_LIBRARY_UPLOAD_RESULT_STATUS_TYPE_FAIL: "Fail",
    
    // 
    FILE_LIBRARY_UPLOAD_RESULT_FILE_FORMAT_NOT_SUPPORTED_TIP: "This file format is not supported.(We accept {{variables}} files)",
    FILE_LIBRARY_UPLOAD_RESULT_FILE_NAME_NOT_SUPPORTED_TIP: 'Illegal file name, The file name cannot contain any of the following characters: \\ \/ \: \* \? \" \< \> \|',
    
    
};

export { language }